<template lang="html">

<div class="svcAdd">

  <div class="headLine">

    <div class="itemGp">
        <el-input v-model="name" size="medium" placeholder="姓名"></el-input>
    </div>

    <div class="itemGp">
        <el-input v-model="phone" size="medium" placeholder="电话"></el-input>
    </div>

    <div class="itemGp">
        <el-input v-model="business" size="medium" placeholder="负责业务"></el-input>
    </div>

    <el-button size="small" style="margin-left:20px;width:80px;" @click="goAdd" type="primary">添加</el-button>

  </div>

  <div v-for="(item,index) in svcList" class="cusLine">
      <span class="iText">{{item.name}}</span>
      <span class="iText">{{item.phone}}</span>
      <span class="iText">{{item.business}}</span>
      <span @click="goRemove(index)" class="ibtn">删除</span>
  </div>


</div>

</template>

<script>
import { userSeek } from "@/api/account";
export default {
    props:['preList'],
    watch:{
        preList:function(e){
            if(e){
                this.svcList = e;
            }
        }
    },
    data(){
        return{
            name:'',
            phone:'',
            business:'',
            svcList:[]
        }
    },
    methods:{
        memberChange:function(e){
            this.itemStore = e;
        },
        goAdd:function(){
            if(this.name && this.phone && this.business){
                this.svcList.push({
                    name:this.name,
                    phone:this.phone,
                    business:this.business
                });

                this.name = '';
                this.phone = '';
                this.business = '';
            }else{
                this.$message.error('业务信息未填写完整！');
            }
        },

        goRemove:function(inx){
            this.svcList.splice(inx,1);
        },

        goSeek(e){
            var querys = this.$route.query;
            if(querys.id){
                userSeek({where:e,no:1,size:20,organizationId:querys.id}).then(res => {
                    vues.seekArr = [];
                    res.userListByWhereList.forEach((item, i) => {
                         if(item.realName){
                             vues.seekArr.push(item);
                         }
                    });
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.headLine{
    position:relative;
    .itemGp{
        display: inline-block;
    }
}

.cusLine{
    margin-top: 12px;
    color: #999999;

    .iText{
        margin-right: 20px;
    }

    .ibtn{
        margin-left: 20px;
        font-size: 14px;
        color: #409EFF;
        cursor: pointer;
    }
}

</style>



// WEBPACK FOOTER //
// svcAdd.vue?7b3eb175